import React from 'react';
import { Link } from 'react-router-dom'
import { Tabs } from '@chakra-ui/react';

import HomeLayout from '../../../components/layouts/homelayout';
import ColumbiaTabPanel from './columbiatabpanel'
import SorelTabPanel from './soreltabpanel'
import MhwTabPanel from './mhwtabpanel'
import PranaTabPanel from './pranatabpanel'

export default function OurBrands() {
  
  return (
    <HomeLayout align="center">
      
          {/* <Tabs.Content value='columbia' p={0}>
            
            <Box
                className='page-banner'
                w={'full'}
                pos={'relative'}
                top={0}
                left={0}
                backgroundColor={'black'}
              >
                <Image
                  src={colBanner} 
                  pos={'relative'}
                  top={0}
                  left={0}
                  //opacity={'.9'}
                  alt='Columbia banner image'
                  w={'full'} 
                />
                <Image src={colLogo}
                  pos={'absolute'}
                  top={0}
                  left={{ base: '250px', md: '500px'}}
                  bottom={0}
                  right={0}
                  margin={'auto'}
                  width={'36%'}
                  alt='Columbia logo'
                />
              </Box>
          
          </Tabs.Content>
          <Tabs.Content value='sorel' p={0}>
          
            <Box
                className='page-banner'
                w={'full'}
                pos={'relative'}
                top={0}
                left={0}
                backgroundColor={'black'}
              >
                <Image
                  src={sorelBanner} 
                  pos={'relative'}
                  top={0}
                  left={0}
                  backgroundColor={'black'}
                  opacity={'.9'}
                  alt='SOREL banner image'
                  w={'full'} 
                />
                <Image src={sorelLogo}
                  pos={'absolute'}
                  top={0}
                  left={{ base: '75px', md: '150px'}}
                  bottom={0}
                  //right={0}
                  margin={'auto'}
                  width={'22%'}
                  alt='SOREL logo'
                />
              </Box>
           
          </Tabs.Content>
          <Tabs.Content value='mhw' p={0}>
              <Image src={mhwBanner} className='page-banner' w={'full'} />
           
          </Tabs.Content>
          <Tabs.Content value='prana' p={0}>
              <Box
                className='page-banner'
                w={'full'}
                pos={'relative'}
                top={0}
                left={0}
                backgroundColor={'black'}
              >
                <Image src={pranaBanner}
                  pos={'relative'}
                  top={0}
                  left={0}
                  opacity={'.7'}
                  alt='prAna banner image'
                  w={'full'}
                />
                <Image src={pranaLogo}
                  pos={'absolute'}
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  margin={'auto'}
                  width={['35%', null, '40%', 'unset']}
                  alt='prAna logo'
                  />
              </Box>
          </Tabs.Content> */}

  <Tabs.Root>
        <Tabs.List>
          <Tabs.Trigger value='columbia' asChild>
            <Link unstyled href="/careers/our-brands-group/?tab-78baa3e833ecb8b09e4=">
              Columbia
            </Link>
          </Tabs.Trigger>
          <Tabs.Trigger value='sorel' asChild>
            <Link unstyled href="/careers/our-brands-group/?tab-9d37deaf387dfeb99f5=">
              SOREL
            </Link>
          </Tabs.Trigger>
          {/* <Tabs.Trigger value='mhw' asChild>Mountain Hardwear</Tabs.Trigger>
          <Tabs.Trigger value='prana' asChild>prAna</Tabs.Trigger> */}
        </Tabs.List>


          <Tabs.Content value='columbia'>
           <ColumbiaTabPanel />
          </Tabs.Content>
          <Tabs.Content value='sorel'>
            <SorelTabPanel />
          </Tabs.Content>
          <Tabs.Content value='mhw'>
            <MhwTabPanel />
          </Tabs.Content>
          <Tabs.Content value='prana'>
            <PranaTabPanel />
          </Tabs.Content>

      </Tabs.Root>
    </HomeLayout>
  );
}
